module.exports = __webpack_public_path__ + "assets/img_doordash.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_doordash.jpg
 ** module id = 120
 ** module chunks = 1
 **/